import type { ApprovalStatus } from "@entrilia/shared/api/workflowTypes";
import StatusChip from "@entrilia/shared/components/StatusChip";

interface Props {
  status: ApprovalStatus;
}

const ApprovalStatusTag = ({ status }: Props) => {
  switch (status) {
    case "Pending": {
      return <StatusChip label="Pending" withDot color={(t) => t.palette.warning.main} />;
    }
    case "Approved":
      return <StatusChip label="Approved" withDot color={(t) => t.palette.success.main} />;
    case "Rejected":
      return <StatusChip label="Rejected" withDot color={(t) => t.palette.error.main} />;
    case "Cancelled":
      return <StatusChip label="Canceled" withDot color={(t) => t.palette.text.secondary} />;
    default:
      return null;
  }
};

export default ApprovalStatusTag;
